// Multilingual translations for Genius WorkPA GmbH
// Languages: DE (default), EN, HR, HU

export const LANGUAGES = [
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "hr", label: "Hrvatski", flag: "🇭🇷" },
  { code: "hu", label: "Magyar", flag: "🇭🇺" },
];

export const translations = {
  de: {
    brand: {
      name: "Genius WorkPA",
      legal: "Genius WorkPA GmbH",
      tagline: "Der intelligente Weg zu qualifiziertem Personal.",
    },
    nav: {
      home: "Start",
      about: "Über uns",
      services: "Leistungen",
      industries: "Branchen",
      locations: "Standorte",
      careers: "Karriere",
      contact: "Kontakt",
      cta: "Anfrage senden",
    },
    hero: {
      eyebrow: "Personaldienstleistungen seit 2007",
      headline: "Flexible Personallösungen für Ihren Unternehmenserfolg",
      subheadline:
        "Über 18 Jahre Erfahrung in Personalvermittlung, Zeitarbeit und Recruiting für Logistik, Lager und Produktion.",
      primary_cta: "Anfrage senden",
      secondary_cta: "Kontakt aufnehmen",
      stats: [
        { value: 18, suffix: "+", label: "Jahre Erfahrung" },
        { value: 500, suffix: "+", label: "Vermittelte Mitarbeiter" },
        { value: 100, suffix: "+", label: "Partnerunternehmen" },
        { value: 4, suffix: "+", label: "Regionen" },
      ],
    },
    about: {
      eyebrow: "Über uns",
      title: "Über Genius WorkPA",
      body:
        "Genius WorkPA GmbH ist eine moderne Personaldienstleistungsfirma mit über 18 Jahren Erfahrung in Personalvermittlung, Recruiting und Arbeitnehmerüberlassung. Wir unterstützen Unternehmen mit qualifizierten Mitarbeitern und schaffen nachhaltige Partnerschaften zwischen Arbeitgebern und Arbeitnehmern.",
      bullets: [
        "Geprüfte und qualifizierte Mitarbeiter",
        "Bundesweite Personalvermittlung",
        "Persönliche Beratung & Betreuung",
      ],
    },
    services: {
      eyebrow: "Leistungen",
      title: "Unsere Personaldienstleistungen",
      subtitle:
        "Maßgeschneiderte Lösungen für Logistik, Lager, Produktion und Industrie.",
      items: [
        {
          title: "Arbeitnehmerüberlassung",
          desc: "Flexible und schnelle Bereitstellung qualifizierter Mitarbeiter für Ihre Projekte.",
        },
        {
          title: "Personalvermittlung",
          desc: "Direkte Vermittlung geeigneter Fachkräfte in Festanstellung.",
        },
        {
          title: "Kurzfristige Personalbereitstellung",
          desc: "Sofortige Unterstützung bei Personalengpässen und Auftragsspitzen.",
        },
        {
          title: "Langfristige Projektunterstützung",
          desc: "Stabile Personalplanung für langfristige Industrieprojekte.",
        },
        {
          title: "Individuelle Personallösungen",
          desc: "Maßgeschneiderte Lösungen, exakt zugeschnitten auf Ihr Unternehmen.",
        },
      ],
    },
    industries: {
      eyebrow: "Branchen",
      title: "Branchenexpertise",
      subtitle:
        "Tiefes Verständnis Ihrer Branche – von Logistik bis E-Commerce.",
      items: [
        { name: "Logistik", desc: "Spedition, Distribution, Transport." },
        { name: "Lager", desc: "Kommissionierung, Wareneingang, Verladung." },
        { name: "Produktion", desc: "Fertigungslinien, Montage, QS." },
        { name: "Industrie", desc: "Anlagenbedienung, Wartung, Logistik." },
        { name: "E-Commerce", desc: "Fulfillment, Versand, Retouren." },
        { name: "Verpackung", desc: "Konfektionierung & Endmontage." },
      ],
    },
    why: {
      eyebrow: "Warum Genius WorkPA",
      title: "Warum Unternehmen uns vertrauen",
      reasons: [
        "Über 18 Jahre Erfahrung",
        "Schnelle Personalvermittlung",
        "Geprüfte Mitarbeiter",
        "Flexible Lösungen",
        "Persönlicher Ansprechpartner",
        "Zuverlässige Zusammenarbeit",
      ],
    },
    locations: {
      eyebrow: "Standorte",
      title: "Bundesweit für Sie vor Ort",
      subtitle:
        "Vier strategische Standorte – wir sind dort, wo Sie uns brauchen.",
      cities: [
        { name: "München", region: "Bayern", lat: 48.1351, lng: 11.582 },
        { name: "Meckenheim", region: "Nordrhein-Westfalen", lat: 50.6256, lng: 7.0298 },
        { name: "Koblenz", region: "Rheinland-Pfalz", lat: 50.3569, lng: 7.5890 },
        { name: "Stuttgart", region: "Baden-Württemberg", lat: 48.7758, lng: 9.1829 },
      ],
    },
    careers: {
      eyebrow: "Karriere",
      title: "Werden Sie Teil unseres Teams",
      subtitle:
        "Wir suchen engagierte Mitarbeiter für Logistik, Lager und Produktion bundesweit.",
      benefits_title: "Ihre Vorteile bei uns",
      benefits: [
        "Übertarifliche Bezahlung",
        "Unbefristete Verträge möglich",
        "Persönliche Betreuung",
        "Weiterbildungsmöglichkeiten",
        "Schichtzulagen & Prämien",
        "Reisekostenerstattung",
      ],
      apply_now: "Jetzt bewerben",
      open_positions: "Offene Stellen",
      form: {
        title: "Online-Bewerbung",
        subtitle: "Schicken Sie uns Ihre Bewerbung – wir melden uns innerhalb von 48 Stunden.",
        name: "Vollständiger Name",
        email: "E-Mail-Adresse",
        phone: "Telefonnummer",
        message: "Anschreiben / Nachricht",
        cv: "Lebenslauf hochladen (PDF, DOC – max. 10MB)",
        cv_choose: "Datei auswählen",
        cv_none: "Keine Datei ausgewählt",
        position: "Position",
        gdpr:
          "Ich willige in die Verarbeitung meiner Daten gemäß Datenschutzerklärung ein.",
        submit: "Bewerbung absenden",
        success: "Vielen Dank! Ihre Bewerbung wurde erfolgreich übermittelt.",
        error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        initiative: "Initiativbewerbung",
      },
    },
    testimonials: {
      eyebrow: "Stimmen",
      title: "Was unsere Partner sagen",
      items: [
        {
          quote:
            "Genius WorkPA hat uns innerhalb von 48 Stunden mit qualifizierten Lageristen versorgt. Absolut zuverlässig.",
          author: "Markus Wagner",
          role: "Logistikleiter, Distribution GmbH",
        },
        {
          quote:
            "Die persönliche Betreuung und die Qualität der Mitarbeiter sind außergewöhnlich. Ein verlässlicher Partner.",
          author: "Sandra Hoffmann",
          role: "HR Director, ProduktionsWerk AG",
        },
        {
          quote:
            "Seit vier Jahren unser bevorzugter Personaldienstleister. Schnell, kompetent, fair.",
          author: "Thomas Bauer",
          role: "Geschäftsführer, E-Commerce Fulfillment",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Sprechen Sie mit uns",
      subtitle:
        "Wir freuen uns auf Ihre Anfrage und melden uns umgehend bei Ihnen zurück.",
      address_title: "Hauptsitz",
      hours_title: "Geschäftszeiten",
      hours_value: "Mo–Fr: 08:00 – 18:00 Uhr",
      form: {
        name: "Name",
        company: "Unternehmen",
        email: "E-Mail",
        phone: "Telefon",
        message: "Ihre Nachricht",
        gdpr:
          "Ich willige in die Verarbeitung meiner Daten gemäß Datenschutzerklärung ein.",
        submit: "Nachricht senden",
        success: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
        error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      },
    },
    footer: {
      tagline: "Der intelligente Weg zu qualifiziertem Personal.",
      quick_links: "Quick Links",
      services: "Leistungen",
      contact: "Kontakt",
      language: "Sprache",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
    },
  },

  en: {
    brand: {
      name: "Genius WorkPA",
      legal: "Genius WorkPA GmbH",
      tagline: "The smart way to qualified workforce.",
    },
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      industries: "Industries",
      locations: "Locations",
      careers: "Careers",
      contact: "Contact",
      cta: "Request a quote",
    },
    hero: {
      eyebrow: "Staffing services since 2007",
      headline: "Flexible workforce solutions for your business success",
      subheadline:
        "Over 18 years of expertise in staffing, temporary employment and recruiting for logistics, warehouse and production.",
      primary_cta: "Request a quote",
      secondary_cta: "Get in touch",
      stats: [
        { value: 18, suffix: "+", label: "Years of experience" },
        { value: 500, suffix: "+", label: "Placed employees" },
        { value: 100, suffix: "+", label: "Partner companies" },
        { value: 4, suffix: "+", label: "Regions served" },
      ],
    },
    about: {
      eyebrow: "About us",
      title: "About Genius WorkPA",
      body:
        "Genius WorkPA GmbH is a modern personnel services company with more than 18 years of experience in recruitment, staffing and temporary employment. We provide companies with qualified employees and build sustainable partnerships between employers and workforce.",
      bullets: [
        "Verified and qualified employees",
        "Nationwide placement",
        "Personal advice & support",
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Our staffing services",
      subtitle:
        "Tailored solutions for logistics, warehouse, production and industry.",
      items: [
        { title: "Temporary employment", desc: "Flexible and fast deployment of qualified employees." },
        { title: "Recruitment", desc: "Direct placement of skilled professionals into permanent roles." },
        { title: "Short-term staffing", desc: "Immediate support during workforce bottlenecks." },
        { title: "Long-term project support", desc: "Stable workforce planning for long-running projects." },
        { title: "Custom workforce solutions", desc: "Tailored solutions for every company." },
      ],
    },
    industries: {
      eyebrow: "Industries",
      title: "Industry expertise",
      subtitle: "Deep understanding of your industry – from logistics to e-commerce.",
      items: [
        { name: "Logistics", desc: "Forwarding, distribution, transport." },
        { name: "Warehouse", desc: "Picking, goods receipt, loading." },
        { name: "Production", desc: "Assembly lines, QA, packaging." },
        { name: "Industry", desc: "Machine operation, maintenance, logistics." },
        { name: "E-Commerce", desc: "Fulfillment, shipping, returns." },
        { name: "Packaging", desc: "Co-packing & finishing." },
      ],
    },
    why: {
      eyebrow: "Why Genius WorkPA",
      title: "Why companies trust us",
      reasons: [
        "Over 18 years of experience",
        "Fast placement",
        "Verified employees",
        "Flexible solutions",
        "Personal contact person",
        "Reliable cooperation",
      ],
    },
    locations: {
      eyebrow: "Locations",
      title: "Nationwide presence",
      subtitle: "Four strategic locations – we are where you need us.",
      cities: [
        { name: "Munich", region: "Bavaria", lat: 48.1351, lng: 11.582 },
        { name: "Meckenheim", region: "North Rhine-Westphalia", lat: 50.6256, lng: 7.0298 },
        { name: "Koblenz", region: "Rhineland-Palatinate", lat: 50.3569, lng: 7.5890 },
        { name: "Stuttgart", region: "Baden-Württemberg", lat: 48.7758, lng: 9.1829 },
      ],
    },
    careers: {
      eyebrow: "Careers",
      title: "Join our team",
      subtitle:
        "We are looking for committed employees in logistics, warehouse and production nationwide.",
      benefits_title: "Your benefits",
      benefits: [
        "Above-tariff pay",
        "Permanent contracts possible",
        "Personal support",
        "Training opportunities",
        "Shift bonuses & premiums",
        "Travel cost reimbursement",
      ],
      apply_now: "Apply now",
      open_positions: "Open positions",
      form: {
        title: "Online application",
        subtitle: "Send us your application – we'll respond within 48 hours.",
        name: "Full name",
        email: "Email address",
        phone: "Phone number",
        message: "Cover letter / message",
        cv: "Upload CV (PDF, DOC – max 10MB)",
        cv_choose: "Choose file",
        cv_none: "No file selected",
        position: "Position",
        gdpr:
          "I consent to the processing of my data according to the privacy policy.",
        submit: "Submit application",
        success: "Thank you! Your application was submitted successfully.",
        error: "An error occurred. Please try again.",
        initiative: "Open application",
      },
    },
    testimonials: {
      eyebrow: "Voices",
      title: "What our partners say",
      items: [
        {
          quote:
            "Genius WorkPA provided us with qualified warehouse staff within 48 hours. Absolutely reliable.",
          author: "Markus Wagner",
          role: "Head of Logistics, Distribution GmbH",
        },
        {
          quote:
            "The personal support and quality of employees are exceptional. A trusted partner.",
          author: "Sandra Hoffmann",
          role: "HR Director, ProductionWorks AG",
        },
        {
          quote: "Our preferred staffing partner for four years. Fast, competent, fair.",
          author: "Thomas Bauer",
          role: "CEO, E-Commerce Fulfillment",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Get in touch",
      subtitle: "We look forward to your inquiry and will respond promptly.",
      address_title: "Headquarters",
      hours_title: "Business hours",
      hours_value: "Mon–Fri: 8:00 AM – 6:00 PM",
      form: {
        name: "Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        message: "Your message",
        gdpr: "I consent to the processing of my data according to the privacy policy.",
        submit: "Send message",
        success: "Thank you! We will get back to you shortly.",
        error: "An error occurred. Please try again.",
      },
    },
    footer: {
      tagline: "The smart way to qualified workforce.",
      quick_links: "Quick links",
      services: "Services",
      contact: "Contact",
      language: "Language",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
    },
  },

  hr: {
    brand: {
      name: "Genius WorkPA",
      legal: "Genius WorkPA GmbH",
      tagline: "Pametan put do kvalitetne radne snage.",
    },
    nav: {
      home: "Početna",
      about: "O nama",
      services: "Usluge",
      industries: "Industrije",
      locations: "Lokacije",
      careers: "Karijera",
      contact: "Kontakt",
      cta: "Pošalji upit",
    },
    hero: {
      eyebrow: "Kadrovske usluge od 2007.",
      headline: "Fleksibilna kadrovska rješenja za uspjeh vašeg poslovanja",
      subheadline:
        "Više od 18 godina iskustva u posredovanju, ustupanju radnika i regrutiranju za logistiku, skladišta i proizvodnju.",
      primary_cta: "Pošalji upit",
      secondary_cta: "Stupite u kontakt",
      stats: [
        { value: 18, suffix: "+", label: "Godina iskustva" },
        { value: 500, suffix: "+", label: "Posredovanih radnika" },
        { value: 100, suffix: "+", label: "Partnerskih tvrtki" },
        { value: 4, suffix: "+", label: "Regija" },
      ],
    },
    about: {
      eyebrow: "O nama",
      title: "O tvrtki Genius WorkPA",
      body:
        "Genius WorkPA GmbH moderna je kadrovska agencija s više od 18 godina iskustva u posredovanju, regrutaciji i ustupanju radnika. Podržavamo tvrtke kvalificiranim zaposlenicima i gradimo dugoročna partnerstva.",
      bullets: [
        "Provjereni i kvalificirani zaposlenici",
        "Posredovanje diljem Njemačke",
        "Osobno savjetovanje i podrška",
      ],
    },
    services: {
      eyebrow: "Usluge",
      title: "Naše kadrovske usluge",
      subtitle:
        "Rješenja prilagođena logistici, skladištu, proizvodnji i industriji.",
      items: [
        { title: "Ustupanje radnika", desc: "Fleksibilno i brzo ustupanje kvalificiranih radnika." },
        { title: "Posredovanje", desc: "Izravno posredovanje stručnjaka u stalni radni odnos." },
        { title: "Kratkoročno ustupanje", desc: "Hitna podrška kod nestašice osoblja." },
        { title: "Dugoročna podrška", desc: "Stabilno planiranje osoblja za dugotrajne projekte." },
        { title: "Prilagođena rješenja", desc: "Rješenja prilagođena svakoj tvrtki." },
      ],
    },
    industries: {
      eyebrow: "Industrije",
      title: "Stručnost u industriji",
      subtitle: "Duboko razumijevanje vaše industrije.",
      items: [
        { name: "Logistika", desc: "Špedicija, distribucija, transport." },
        { name: "Skladište", desc: "Komisioniranje, prijem robe, utovar." },
        { name: "Proizvodnja", desc: "Linije, montaža, kontrola kvalitete." },
        { name: "Industrija", desc: "Rukovanje strojevima, održavanje." },
        { name: "E-trgovina", desc: "Fulfillment, otprema, povrati." },
        { name: "Pakiranje", desc: "Co-packing i završni radovi." },
      ],
    },
    why: {
      eyebrow: "Zašto Genius WorkPA",
      title: "Zašto nam tvrtke vjeruju",
      reasons: [
        "Više od 18 godina iskustva",
        "Brzo posredovanje",
        "Provjereni radnici",
        "Fleksibilna rješenja",
        "Osobni kontakt",
        "Pouzdana suradnja",
      ],
    },
    locations: {
      eyebrow: "Lokacije",
      title: "Prisutnost diljem zemlje",
      subtitle: "Četiri strateške lokacije.",
      cities: [
        { name: "München", region: "Bavarska", lat: 48.1351, lng: 11.582 },
        { name: "Meckenheim", region: "Sjeverna Rajna-Vestfalija", lat: 50.6256, lng: 7.0298 },
        { name: "Koblenz", region: "Falačka", lat: 50.3569, lng: 7.5890 },
        { name: "Stuttgart", region: "Baden-Württemberg", lat: 48.7758, lng: 9.1829 },
      ],
    },
    careers: {
      eyebrow: "Karijera",
      title: "Postanite dio našeg tima",
      subtitle:
        "Tražimo predane zaposlenike za logistiku, skladište i proizvodnju.",
      benefits_title: "Vaše pogodnosti",
      benefits: [
        "Plaća iznad tarife",
        "Mogući ugovori na neodređeno",
        "Osobna podrška",
        "Mogućnosti usavršavanja",
        "Dodaci za smjene",
        "Naknada putnih troškova",
      ],
      apply_now: "Prijavite se",
      open_positions: "Otvorene pozicije",
      form: {
        title: "Online prijava",
        subtitle: "Pošaljite prijavu – javljamo se u roku 48 sati.",
        name: "Puno ime",
        email: "E-mail adresa",
        phone: "Telefonski broj",
        message: "Popratno pismo / poruka",
        cv: "Učitajte životopis (PDF, DOC – max 10MB)",
        cv_choose: "Odaberite datoteku",
        cv_none: "Nema odabrane datoteke",
        position: "Pozicija",
        gdpr: "Slažem se s obradom podataka prema politici privatnosti.",
        submit: "Pošalji prijavu",
        success: "Hvala! Vaša prijava je uspješno poslana.",
        error: "Došlo je do greške. Pokušajte ponovno.",
        initiative: "Otvorena prijava",
      },
    },
    testimonials: {
      eyebrow: "Glasovi",
      title: "Što kažu naši partneri",
      items: [
        {
          quote:
            "Genius WorkPA nam je u 48 sati osigurao kvalificirane skladištare. Apsolutno pouzdano.",
          author: "Markus Wagner",
          role: "Voditelj logistike, Distribution GmbH",
        },
        {
          quote:
            "Osobna podrška i kvaliteta radnika su izvanredne. Pouzdan partner.",
          author: "Sandra Hoffmann",
          role: "HR direktorica, ProduktionsWerk AG",
        },
        {
          quote: "Naš omiljeni kadrovski partner već četiri godine.",
          author: "Thomas Bauer",
          role: "Direktor, E-Commerce Fulfillment",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Razgovarajmo",
      subtitle: "Veselimo se vašem upitu.",
      address_title: "Sjedište",
      hours_title: "Radno vrijeme",
      hours_value: "Pon–Pet: 08:00 – 18:00",
      form: {
        name: "Ime",
        company: "Tvrtka",
        email: "E-mail",
        phone: "Telefon",
        message: "Vaša poruka",
        gdpr: "Slažem se s obradom podataka prema politici privatnosti.",
        submit: "Pošalji poruku",
        success: "Hvala! Uskoro ćemo vam se javiti.",
        error: "Došlo je do greške. Pokušajte ponovno.",
      },
    },
    footer: {
      tagline: "Pametan put do kvalitetne radne snage.",
      quick_links: "Brze poveznice",
      services: "Usluge",
      contact: "Kontakt",
      language: "Jezik",
      rights: "Sva prava pridržana.",
      imprint: "Impressum",
      privacy: "Privatnost",
      terms: "Uvjeti",
    },
  },

  hu: {
    brand: {
      name: "Genius WorkPA",
      legal: "Genius WorkPA GmbH",
      tagline: "Az intelligens út a minőségi munkaerőhöz.",
    },
    nav: {
      home: "Kezdőlap",
      about: "Rólunk",
      services: "Szolgáltatások",
      industries: "Iparágak",
      locations: "Telephelyek",
      careers: "Karrier",
      contact: "Kapcsolat",
      cta: "Ajánlatkérés",
    },
    hero: {
      eyebrow: "Munkaerő-közvetítés 2007 óta",
      headline: "Rugalmas munkaerő-megoldások üzleti sikeréhez",
      subheadline:
        "Több mint 18 év tapasztalat munkaerő-közvetítésben, kölcsönzésben és toborzásban logisztika, raktár és termelés területén.",
      primary_cta: "Ajánlatkérés",
      secondary_cta: "Vegye fel a kapcsolatot",
      stats: [
        { value: 18, suffix: "+", label: "Év tapasztalat" },
        { value: 500, suffix: "+", label: "Közvetített munkavállaló" },
        { value: 100, suffix: "+", label: "Partner vállalat" },
        { value: 4, suffix: "+", label: "Régió" },
      ],
    },
    about: {
      eyebrow: "Rólunk",
      title: "A Genius WorkPA-ról",
      body:
        "A Genius WorkPA GmbH modern munkaerő-közvetítő cég több mint 18 éves tapasztalattal toborzásban, közvetítésben és munkaerő-kölcsönzésben. Képzett munkaerővel támogatjuk a vállalatokat.",
      bullets: [
        "Ellenőrzött és képzett munkavállalók",
        "Országos közvetítés",
        "Személyes tanácsadás",
      ],
    },
    services: {
      eyebrow: "Szolgáltatások",
      title: "Munkaerő-szolgáltatásaink",
      subtitle: "Testreszabott megoldások logisztikára, raktárra, termelésre.",
      items: [
        { title: "Munkaerő-kölcsönzés", desc: "Rugalmas és gyors képzett munkaerő biztosítása." },
        { title: "Munkaerő-közvetítés", desc: "Szakemberek közvetlen közvetítése állandó állásba." },
        { title: "Rövid távú biztosítás", desc: "Azonnali támogatás munkaerőhiány esetén." },
        { title: "Hosszú távú támogatás", desc: "Stabil munkaerő-tervezés hosszú projektekre." },
        { title: "Egyedi megoldások", desc: "Minden vállalatra szabott megoldások." },
      ],
    },
    industries: {
      eyebrow: "Iparágak",
      title: "Iparági szakértelem",
      subtitle: "Iparágának mély ismerete.",
      items: [
        { name: "Logisztika", desc: "Szállítmányozás, disztribúció, fuvarozás." },
        { name: "Raktár", desc: "Komissiózás, áruátvétel, rakodás." },
        { name: "Termelés", desc: "Gyártósorok, összeszerelés, MEO." },
        { name: "Ipar", desc: "Gépkezelés, karbantartás, logisztika." },
        { name: "E-kereskedelem", desc: "Fulfillment, szállítás, visszáru." },
        { name: "Csomagolás", desc: "Co-packing és befejező munka." },
      ],
    },
    why: {
      eyebrow: "Miért Genius WorkPA",
      title: "Miért bíznak bennünk a vállalatok",
      reasons: [
        "Több mint 18 év tapasztalat",
        "Gyors közvetítés",
        "Ellenőrzött munkavállalók",
        "Rugalmas megoldások",
        "Személyes kapcsolattartó",
        "Megbízható együttműködés",
      ],
    },
    locations: {
      eyebrow: "Telephelyek",
      title: "Országos jelenlét",
      subtitle: "Négy stratégiai telephely.",
      cities: [
        { name: "München", region: "Bajorország", lat: 48.1351, lng: 11.582 },
        { name: "Meckenheim", region: "Észak-Rajna-Vesztfália", lat: 50.6256, lng: 7.0298 },
        { name: "Koblenz", region: "Rajna-vidék-Pfalz", lat: 50.3569, lng: 7.5890 },
        { name: "Stuttgart", region: "Baden-Württemberg", lat: 48.7758, lng: 9.1829 },
      ],
    },
    careers: {
      eyebrow: "Karrier",
      title: "Csatlakozzon csapatunkhoz",
      subtitle:
        "Elkötelezett munkavállalókat keresünk logisztikára, raktárra és termelésre.",
      benefits_title: "Előnyei nálunk",
      benefits: [
        "Tarifa feletti fizetés",
        "Határozatlan szerződés lehetséges",
        "Személyes támogatás",
        "Továbbképzések",
        "Műszakpótlékok",
        "Utazási költségtérítés",
      ],
      apply_now: "Jelentkezzen most",
      open_positions: "Nyitott pozíciók",
      form: {
        title: "Online jelentkezés",
        subtitle: "Küldje el jelentkezését – 48 órán belül válaszolunk.",
        name: "Teljes név",
        email: "E-mail cím",
        phone: "Telefonszám",
        message: "Motivációs levél / üzenet",
        cv: "Önéletrajz feltöltése (PDF, DOC – max 10MB)",
        cv_choose: "Fájl választása",
        cv_none: "Nincs kiválasztott fájl",
        position: "Pozíció",
        gdpr: "Hozzájárulok adataim adatvédelmi szabályzat szerinti kezeléséhez.",
        submit: "Jelentkezés elküldése",
        success: "Köszönjük! Jelentkezését sikeresen elküldtük.",
        error: "Hiba történt. Próbálja újra.",
        initiative: "Általános jelentkezés",
      },
    },
    testimonials: {
      eyebrow: "Vélemények",
      title: "Mit mondanak partnereink",
      items: [
        {
          quote:
            "A Genius WorkPA 48 órán belül képzett raktárosokat biztosított. Teljesen megbízható.",
          author: "Markus Wagner",
          role: "Logisztikai vezető, Distribution GmbH",
        },
        {
          quote:
            "A személyes támogatás és a munkavállalók minősége kivételes.",
          author: "Sandra Hoffmann",
          role: "HR igazgató, ProduktionsWerk AG",
        },
        {
          quote: "Négy éve a kedvenc munkaerő-partnerünk.",
          author: "Thomas Bauer",
          role: "Ügyvezető, E-Commerce Fulfillment",
        },
      ],
    },
    contact: {
      eyebrow: "Kapcsolat",
      title: "Beszéljünk",
      subtitle: "Várjuk megkeresését.",
      address_title: "Központ",
      hours_title: "Nyitvatartás",
      hours_value: "Hé–Pé: 08:00 – 18:00",
      form: {
        name: "Név",
        company: "Vállalat",
        email: "E-mail",
        phone: "Telefon",
        message: "Üzenet",
        gdpr: "Hozzájárulok adataim adatvédelmi szabályzat szerinti kezeléséhez.",
        submit: "Üzenet küldése",
        success: "Köszönjük! Hamarosan jelentkezünk.",
        error: "Hiba történt. Próbálja újra.",
      },
    },
    footer: {
      tagline: "Az intelligens út a minőségi munkaerőhöz.",
      quick_links: "Gyors linkek",
      services: "Szolgáltatások",
      contact: "Kapcsolat",
      language: "Nyelv",
      rights: "Minden jog fenntartva.",
      imprint: "Impresszum",
      privacy: "Adatvédelem",
      terms: "Feltételek",
    },
  },
};
